<template>
  <div class="tw-relative">
    <trends-cards :start-date="startDate" />
    <div class="tw-mb-6 tw-grid tw-grid-cols-9 tw-gap-6 max-xl:tw-grid-cols-1">
      <div class="tw-col-span-6 max-xl:tw-col-span-1">
        <usage-per-solution
          class="tw-h-full"
          data-test-id="msp-usage-per-solution"
        />
      </div>
      <div class="tw-col-span-3 max-xl:tw-col-span-1">
        <quick-actions></quick-actions>
      </div>
    </div>
    <div class="tw-mb-6 tw-grid tw-grid-cols-9 tw-gap-6 max-xl:tw-grid-cols-1">
      <div class="tw-col-span-6 max-xl:tw-col-span-1">
        <emails-chart
          v-if="isSolutionActive(PHISH_SERVICE)"
          :start-date="startDate"
          tier="msp"
        />
        <emails-chart-placeholder v-else />
      </div>
      <div class="tw-col-span-3 max-xl:tw-col-span-1">
        <targeted-users
          v-if="isSolutionActive(PHISH_SERVICE)"
          :start-date="startDate"
        />
        <targeted-users-placeholder v-else />
      </div>
    </div>

    <div class="tw-mb-6" v-if="isChartAvailable">
      <trend-chart-index
        :is-phs-active="isSolutionActive(PHISHING_SIMULATION)"
        :is-sat-active="isSolutionActive(SAT_SERVICE)"
      />
    </div>
    <div
      class="tw-mb-6 tw-grid tw-grid-cols-9 tw-gap-6 max-xl:tw-grid-cols-1"
      v-else
    >
      <div class="tw-col-span-4 max-xl:tw-col-span-1">
        <lures-chart
          v-if="isSolutionActive(PHISHING_SIMULATION)"
          class="tw-h-[100%]"
        ></lures-chart>
        <lures-chart-placeholder v-else />
      </div>
      <div class="tw-col-span-5 max-xl:tw-col-span-1">
        <s-a-t-trainings v-if="isSolutionActive(SAT_SERVICE)"></s-a-t-trainings>
        <s-a-t-trainings-placeholder v-else />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";
import EmailsChart from "@/components/EmailsChart/index.vue";
import TargetedUsers from "@/components/TargetedUsers/index.vue";
import UsagePerSolution from "@/components/UsagePerSolution/index.vue";
import TrendsCards from "../TrendsCards/index.vue";
import TargetedUsersPlaceholder from "../../components/TargetedUsersPlaceholder/TargetedUsersPlaceholder.vue";
import EmailsChartPlaceholder from "../../components/EmailsChartPlaceholder/EmailsChartPlaceholder.vue";
import QuickActions from "../../components/QuickActions/QuickActions.vue";
import { useActiveSolutions } from "@/composables/useActiveSolutions";
import {
  PHISH_SERVICE,
  PHISHING_SIMULATION,
  SAT_SERVICE,
} from "@/utils/services";
import LuresChart from "../../components/LuresChart/index.vue";
import LuresChartPlaceholder from "../../components/LuresChartPlaceholder/LuresChartPlaceholder.vue";
import SATTrainingsPlaceholder from "../../components/SATTrainingsPlaceholder/SATTrainingsPlaceholder.vue";
import SATTrainings from "../../components/SATTrainings/SATTrainings.vue";
import TrendChartIndex from "./trend-chart/trend-chart.index.vue";

import {
  Period,
  getDateFromPeriod,
} from "@/modules/PhishTitan/utils/getDateFromPeriod";
import { useFlag } from "@/composables/useFlags/useFlag";
import { usePageMetaStore } from "@/store/pageMeta.store";

const pageMetaStore = usePageMetaStore();
const { isSolutionActive } = useActiveSolutions();
const { isFeatureAvailable: isChartAvailable } = useFlag("MSP_OVERVIEW_CHART");

pageMetaStore.setPageTitle({ title: "Dashboard" });

const selectedPeriod = ref<Period>("month");
const startDate = computed(() => getDateFromPeriod(selectedPeriod.value));
</script>
